import React from "react";
import HomePage from "../components/home";

export default function Home() {
    return (
        <div>
            <HomePage />
        </div>
    )
}